<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useStore } from 'vuex'

const store = useStore()
const niftyLevel = ref(null)
const previousDayNiftyLevel = ref(null)
const countdown = ref(30)
const diff = ref(0)

let intervalId = null
let timerId = null

const isMarketOpen = () => {
  const now = new Date()
  const day = now.getDay() // 0=Sunday, 6=Saturday
  const hours = now.getHours()
  const minutes = now.getMinutes()

  // Market hours: 9:15 AM to 3:30 PM, Monday to Friday
  if (day === 0 || day === 6) return false
  if (hours < 9 || (hours === 9 && minutes < 15) || (hours === 15 && minutes > 30) || hours > 15) return false

  return true
}

const fetchNifty = async () => {
  try {
    const res = await store.dispatch('trades/refreshNiftyLevel')

    niftyLevel.value = res?.niftyLevel
    previousDayNiftyLevel.value = res?.previousDayNiftyLevel
    diff.value =
      niftyLevel.value != null && previousDayNiftyLevel.value != null
        ? +(niftyLevel.value - previousDayNiftyLevel.value).toFixed(2)
        : 0
  } catch (e) {
    console.error('Failed to fetch Nifty level', e)
  }
  countdown.value = 30 // Reset countdown after fetch
}

const fetchIfMarketOpen = () => {
  if (isMarketOpen()) {
    fetchNifty()
  }
}

onMounted(() => {
  fetchNifty() // Initial fetch

  timerId = setInterval(() => {
    if (countdown.value > 0) {
      countdown.value--
    }
  }, 1000)

  // Refresh every 30 seconds
  intervalId = setInterval(fetchIfMarketOpen, 30000)
})

onBeforeUnmount(() => {
  clearInterval(intervalId)
  clearInterval(timerId)
})

const getColorClass = (value) => {
  return Number(value) >= 0 ? 'text-green-lighten-1' : 'text-red-lighten-1';
};
</script>

<template>
  <div class="d-flex justify-space-between align-center flex-wrap ga-2 text-body-2">
    <div v-if="niftyLevel !== null">
      <span class="font-weight-bold">NIFTY: </span>
      <span class="font-weight-bold" :class="getColorClass(diff)">
        {{ niftyLevel.toLocaleString('en-IN') }} ({{ diff >= 0 ? '+' : '' }}{{ diff }})
      </span>
      <span class="text-caption text-grey-lighten-2 ml-1">({{ countdown }}s)</span>
    </div>
    <div v-else>
      <span class="font-weight-bold">NIFTY: </span>
      <span class="text-grey-lighten-1">Loading...</span>
    </div>
  
    <slot :currentLevel="niftyLevel"></slot>
  </div>
</template>

<style scoped>
/* Ensure colors match the parent component's theme */
.text-red-lighten-1 {
  color: #EF5350 !important;
}

.text-green-lighten-1 {
  color: #66BB6A !important;
}
</style>